module.exports = __webpack_public_path__ + "web/img/verify1.8238a78c.png";